import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/panda/css';
import { DEFAULT_PIN_COLOR } from '@repo/store/maps/utils/mapData';
import type { MapData, MapDataLocationFeature } from '@repo/types/maps/map-types';
import { getFontInfoForGlyph, getIconForGlyph, getSubcategoryIconStyle } from '@repo/types/maps/map-utils';
import { getPinImageUrl, getSteamImageUrl } from '@repo/utility/image-urls';
import type React from 'react';
import { useMemo } from 'react';
import { buildCategoryMap, buildSubcategoryMap } from './checklist-utils';
export const checklistHeroIconClass = css({
  width: '[48px]',
  height: '[48px]',
  minWidth: '[48px]',
  minHeight: '[48px]',
  borderRadius: 'full',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '2xl',
  color: 'white',
  boxShadow: 'sm',
  backdropFilter: '[blur(8px)]',
  border: 'none'
});
export function getFeatureImageUrl(feature: MapDataLocationFeature | undefined): string | null {
  if (!feature) return null;
  return getPinImageUrl(feature.properties.imageId, feature.properties.imagePath, 750);
}
interface ChecklistHero {
  backgroundImageUrl: string;
  pinColor: string;
  iconChar: string;
  iconFontStyle: React.CSSProperties;
}
export function useChecklistHero(pinFeatures, mapData, steamId) {
  const $ = _c(24);
  let t0;
  bb0: {
    if (!mapData) {
      t0 = null;
      break bb0;
    }
    let t1;
    if ($[0] !== mapData) {
      t1 = buildSubcategoryMap(mapData);
      $[0] = mapData;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== mapData) {
      t2 = buildCategoryMap(mapData);
      $[2] = mapData;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
      t3 = {
        subcategoryMap: t1,
        categoryMap: t2
      };
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t0 = t3;
  }
  const lookups = t0;
  let t1;
  if ($[7] !== pinFeatures) {
    t1 = pinFeatures.find(getFeatureImageUrl) ?? pinFeatures[0] ?? null;
    $[7] = pinFeatures;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const heroPin = t1;
  let t2;
  bb1: {
    const t3 = heroPin ?? undefined;
    let t4;
    if ($[9] !== t3) {
      t4 = getFeatureImageUrl(t3);
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    const heroImage = t4;
    if (heroImage) {
      t2 = heroImage;
      break bb1;
    }
    let t5;
    if ($[11] !== steamId) {
      t5 = steamId ? getSteamImageUrl(steamId, "hero") : "";
      $[11] = steamId;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t2 = t5;
  }
  const backgroundImageUrl = t2;
  let heroCategory;
  let iconChar;
  let t3;
  if ($[13] !== heroPin || $[14] !== lookups?.categoryMap || $[15] !== lookups?.subcategoryMap) {
    const heroSubcategory = heroPin ? lookups?.subcategoryMap.get(heroPin.properties.subcategoryExternalId) ?? null : null;
    heroCategory = heroSubcategory ? lookups?.categoryMap.get(heroSubcategory.categoryExternalId) ?? null : null;
    const iconGlyph = heroSubcategory?.icon ?? "category";
    const fontInfo = getFontInfoForGlyph(iconGlyph);
    iconChar = getIconForGlyph(iconGlyph);
    t3 = getSubcategoryIconStyle(fontInfo.fontName);
    $[13] = heroPin;
    $[14] = lookups?.categoryMap;
    $[15] = lookups?.subcategoryMap;
    $[16] = heroCategory;
    $[17] = iconChar;
    $[18] = t3;
  } else {
    heroCategory = $[16];
    iconChar = $[17];
    t3 = $[18];
  }
  const iconFontStyle = t3;
  const pinColor = heroCategory?.color ?? DEFAULT_PIN_COLOR;
  let t4;
  if ($[19] !== backgroundImageUrl || $[20] !== iconChar || $[21] !== iconFontStyle || $[22] !== pinColor) {
    t4 = {
      backgroundImageUrl,
      pinColor,
      iconChar,
      iconFontStyle
    };
    $[19] = backgroundImageUrl;
    $[20] = iconChar;
    $[21] = iconFontStyle;
    $[22] = pinColor;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
}